import React from 'react';
import { fieldPropTypes } from 'redux-form';
import { AutocompleteSimpleField } from 'components/FormFieldsSimple/AutocompleteSimpleField';
import { SearchIcon } from 'components/SvgIcons';
import { ReduxFormElementWrapper } from '../_ReduxFormElementWrapper';

/**
 * @deprecated
 * Use AutocompleteTextInput instead
 */
export class AutocompleteField extends React.PureComponent {
  static propTypes = {
    ...fieldPropTypes,
  };

  render() {
    const { input, label, ...tailProps } = this.props;

    return (
      <ReduxFormElementWrapper {...this.props} childrenMarginTop="14px">
        <AutocompleteSimpleField
          {...tailProps}
          name={input.name}
          label={label}
          icon={SearchIcon}
          onChange={(value) => input.onChange(value)}
          onFocus={input.onFocus}
          onBlur={input.onBlur}
          value={input.value}
        />
      </ReduxFormElementWrapper>
    );
  }
}
